import classNames from 'classnames';
import {ReactNode, useCallback} from 'react';

type Props = {
    pageNumber: number;
    selected?: boolean;
    disabled?: boolean;
    ellipsis?: boolean;
    children: ReactNode;
    onSelect?: (page: number) => void;
}

export const PageItem = ({pageNumber, ellipsis, selected, disabled, children, onSelect}: Props) => {
    const onClick = useCallback(() => {
        if (disabled || selected || ellipsis) {
            return;
        }
        onSelect?.(pageNumber);
    }, [disabled, selected, pageNumber, onSelect, ellipsis]);

    if (ellipsis) {
        return (
            <div className='tw-px-3 tw-text-md tw-opacity-25 tw-font-bold'>
                {'...'}
            </div>
        );
    }

    return (
        <div
            className={classNames(
                'tw-flex tw-border-b-2 tw-items-center tw-justify-center',
                'tw-mx-1 tw-p-2 tw-pb-1.5 tw-bg-light tw-min-w-8', {
                    'tw-text-primary tw-border-primary tw-cursor-default': selected,
                    'tw-border-light': !selected,
                    'tw-cursor-pointer': !selected && !disabled,
                    'tw-text-default-dimmed tw-cursor-default tw-text-opacity-30': disabled
                })}
            onClick={onClick}
        >
            {children}
        </div>
    );
};
